import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="text-xs text-slate-500 hover:text-slate-900">← Home</Link>
        <h1 className="mt-4 font-heading text-4xl font-bold tracking-tighter text-slate-900" data-testid="privacy-title">Privacy Policy</h1>
        <p className="mt-2 text-sm text-slate-500">Last updated February 2026</p>

        <div className="mt-10 prose prose-slate max-w-none text-slate-700">
          <p>This Privacy Policy explains what iKEY collects, why, and how you can control it.</p>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">What we collect</h2>
          <ul>
            <li><b>Account info</b>: email, name, brokerage details, brand color, logo.</li>
            <li><b>CRM data</b>: leads, transactions, deadlines, documents, notes, activity you record.</li>
            <li><b>Client portal data</b>: clients you invite, magic-link tokens (hashed), messages and documents they upload.</li>
            <li><b>Usage</b>: standard server logs (IP, timestamp, route). No third-party analytics.</li>
            <li><b>Billing</b>: Stripe handles payment info. We store a Stripe customer id, never a card number.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">How we use it</h2>
          <p>Data is used to operate the Service — scoring your leads, generating deadlines, sending emails and push notifications you configure. We do not sell your data.</p>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">AI processing</h2>
          <p>When you use AI features (message drafting, portal Ask, model compare), the minimum context needed is sent to our LLM provider (Emergent's managed integration wrapping Anthropic / OpenAI / Gemini). Providers do not train models on your workspace data.</p>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">Where it lives</h2>
          <p>Storage runs on Supabase (US-West). Row-Level Security ensures your workspace is only readable by you (and by teammates in your brokerage, if you have one). Files uploaded to the client portal live in Supabase Storage with signed-URL access.</p>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">Sub-processors</h2>
          <ul>
            <li>Supabase — database, auth, file storage</li>
            <li>Stripe — payment processing &amp; Stripe Tax</li>
            <li>DocuSign — e-signature envelopes on paid tiers (envelope status, signer email, audit trail)</li>
            <li>Resend — transactional email</li>
            <li>Emergent LLM (Anthropic, OpenAI, Gemini) — AI message drafting and portal Q&amp;A</li>
            <li>Expo Push — mobile notifications</li>
            <li>Google Analytics 4 — anonymised product analytics (page views, conversions)</li>
          </ul>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">Your controls</h2>
          <ul>
            <li>Export any lead / transaction from the app UI (CSV download).</li>
            <li>Delete your workspace via Settings → Account. This removes all your data within 30 days.</li>
            <li>Revoke a client portal magic link at any time.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold mt-8 mb-3 text-slate-900">Contact</h2>
          <p>Privacy questions: reach us via the in-app support link.</p>
        </div>
      </div>
    </div>
  );
}
